import React from "react";
import "./Footer.css";
export default function Footer() {
  return (
    <div className="FooterDiv">
      <p className="FooterP">Nalin Agrawal © 2021</p>
    </div>
  );
}
